import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { removeToken, getToken } from '../../utils/auth';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const isLoggedIn = !!getToken();
  const menuRef = useRef();
  const hamburgerRef = useRef();
  const location = useLocation();

  useEffect(() => {
    console.log('Header component mounted');

    const publicRoutes = ['/', '/register', '/about', '/forgot-password', '/reset-password'];

    if (!isLoggedIn && !publicRoutes.includes(location.pathname)) {
      navigate("/login");
    }

    const handleClickOutside = (event) => {
      if (
        menuRef.current && !menuRef.current.contains(event.target) &&
        hamburgerRef.current && !hamburgerRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => document.removeEventListener('click', handleClickOutside);
  }, [isLoggedIn, navigate, location.pathname]);

  useEffect(() => {
    setIsOpen(false); 
  }, [location]);

  const handleLogout = () => {
    removeToken();
    navigate("/login");
  };

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <header className="header">
      <nav className="navbar">
        <div className="menu-group">
          <div className="hamburger" ref={hamburgerRef} onClick={toggleMenu}>
            <span></span>
            <span></span>
            <span></span>
          </div>
          <div className={`menu ${isOpen ? 'open' : ''}`} ref={menuRef}>
            <ul>
              {isLoggedIn ? (
                <>
                  <li><Link to="/agenda" onClick={toggleMenu}>Agenda</Link></li>
                  <li><Link to="/discover" onClick={toggleMenu}>Discover</Link></li>
                  <li><Link to="/whats-hot" onClick={toggleMenu}>What's Hot</Link></li>
                  <li><Link to="/jobs" onClick={toggleMenu}>Jobs</Link></li>
                  <li><Link to="/about" onClick={toggleMenu}>About</Link></li>
                  <li className="logout-menu-item"><Link to="/" onClick={handleLogout} className="logout-link">Log Out</Link></li>
                </>
              ) : (
                <>
                  <li><Link to="/login" onClick={toggleMenu}>Log In</Link></li>
                  <li><Link to="/register" onClick={toggleMenu}>Register</Link></li>
                  <li><Link to="/about" onClick={toggleMenu}>About</Link></li>
                </>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;